import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { schedulePreferencesPatch } from '@/composables/useUserPreferences'
import { getMarketingAckState, setMarketingAckState } from '@/utils/iphoneTopMarketingStorage.js'

export function useIphoneTopMarketingAck () {
  const authStore = useAuthStore()
  const userId = computed(() => authStore.user?.id)

  function hasSeenMarketing () {
    const id = userId.value
    if (!id) {
      return true
    }
    const local = getMarketingAckState(id)
    if (local === 'seen' || local === 'completed') {
      return true
    }
    const ackAt = authStore.user?.preferences?.ui?.iphoneTopMarketingAckAt
    return !!ackAt
  }

  function persistMarketingAck (mode = 'seen') {
    const id = userId.value
    if (!id) {
      return
    }
    setMarketingAckState(id, mode)
    schedulePreferencesPatch({
      ui: { iphoneTopMarketingAckAt: new Date().toISOString() }
    })
  }

  return {
    hasSeenMarketing,
    persistMarketingAck
  }
}
